export const BRAND_COLOR_TOKENS = {
  primary: '#5850A0',
  indigo: '#201848',
  violet: '#7870B0',
  lightLavender: '#A098C8',
  paleLavender: '#C8C0E0',
  veryPaleLavender: '#F0F0F8',
  white: '#FFFFFF',
  offWhite: '#FAFAFF',
  border: '#E4E0F2',
  muted: '#6F6A8F',
  successBackground: '#DFF4E6',
  successText: '#3C8A58',
  warningBackground: '#F7EFD8',
  warningText: '#9A7632',
  disabledBackground: '#ECEAF2',
  disabledText: '#9A96AD',
  errorBackground: '#FDE7E7',
  errorText: '#A33A3A',
  errorBorder: '#F3B6B6',
} as const;

export type BrandColorTokenName = keyof typeof BRAND_COLOR_TOKENS;
